var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikeHeartIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.416 13.873c-.227.08-.6.08-.827 0-1.933-.66-6.253-3.413-6.253-8.08 0-2.06 1.66-3.727 3.707-3.727 1.213 0 2.286.587 2.96 1.494a3.686 3.686 0 012.96-1.494c2.046 0 3.706 1.667 3.706 3.727 0 4.667-4.32 7.42-6.253 8.08z",
    stroke: "#000",
    strokeOpacity: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgLikeHeartIcon;